import { defaultSettings } from "css/defaultAntStyles";
import React from "react";

export const MyLogo = ({
  fontSize = 16,
  marginRight = 0,
  display = "flex",
  borderRadius = 8,
  padding = "6px 16px",
}) => {
  return (
    <div
      style={{
        display,
        alignItems: "center",
        justifyContent: "center",
        marginRight,
      }}
    >
      <span
        style={{
          fontWeight: 700,
          fontSize,
          padding,
          border: `3px solid ${defaultSettings.colorPrimary}`,
          borderRadius,
          color: defaultSettings.colorPrimary,
          letterSpacing: 0.5,
          lineHeight: 1,
        }}
      >
        E-Form
      </span>
    </div>
  );
};
